import { ENV_NAME, getEnvironment } from '@heidi/api/config';
import { atom } from 'jotai';

import type { ClinicianTrialEndedUsageClass } from './classify-clinician-trial-usage';

export type ClinicianTrialEndDevOverride = {
  /** Fixed when forced, so dismissals key on a stable end. */
  trialEnd: string;
  usageClass: ClinicianTrialEndedUsageClass;
};

// In memory only, so a forced trial never outlives a reload or sign-out.
export const clinicianTrialEndDevOverrideAtom = atom<ClinicianTrialEndDevOverride | null>(
  null
);

/** Forces the trial extension checklist as completed or not; `null` reads the real state. */
export const clinicianTrialExtensionDevOverrideAtom = atom<{ completed: boolean } | null>(
  null
);

/** The forced trial, or `null` when no override applies or in production. */
export function applyClinicianTrialEndDevOverride(
  override: ClinicianTrialEndDevOverride | null
): ClinicianTrialEndDevOverride | null {
  if (override == null || getEnvironment() === ENV_NAME.PROD) return null;
  return override;
}

/** The forced extension state, or `null` when no override applies or in production. */
export function applyClinicianTrialExtensionDevOverride(
  override: { completed: boolean } | null
): { completed: boolean } | null {
  if (override == null || getEnvironment() === ENV_NAME.PROD) return null;
  return override;
}
